import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // localStorage'dan tema tercihini al veya varsayılan olarak sistem temasını kullan
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Tema değiştiğinde HTML class'ını ve localStorage'ı güncelle
  useEffect(() => {
    const root = document.documentElement;
    const transitionDuration = '300ms';

    // Geçiş animasyonunu ekle
    root.style.setProperty('--theme-transition-duration', transitionDuration);
    root.style.transition = `background-color var(--theme-transition-duration) ease-in-out, 
                           color var(--theme-transition-duration) ease-in-out`;

    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
      // Tema değişim eventi yayınla
      window.dispatchEvent(new CustomEvent('themeChanged', { detail: { isDark: true } }));
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
      // Tema değişim eventi yayınla
      window.dispatchEvent(new CustomEvent('themeChanged', { detail: { isDark: false } }));
    }

    // Cleanup
    return () => {
      root.style.removeProperty('--theme-transition-duration');
      root.style.transition = '';
    };
  }, [isDark]);

  // Sistem teması değişikliğini dinle
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (!localStorage.getItem('theme')) {
        setIsDark(e.matches);
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const toggleTheme = () => {
    setIsDark(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 